import React, { Component } from 'react';
import Row from 'react-bootstrap/lib/Row';
import Col from 'react-bootstrap/lib/Col';
import {
  Portlet,
  PortletBody,
  PortletCaption,
  PortletTitle,
} from '../components/Bootstrap/Portlet';

class ErrorBoundary extends Component {
  constructor(props) {
    super(props);
    this.state = { error: null, errorInfo: null };
  }

  componentDidCatch(error, errorInfo) {
    this.setState({
      error: error,
      errorInfo: errorInfo,
    });
  }

  render() {
    return (
      <React.Fragment>
        {this.props.children}
        {this.state.errorInfo && (
          <Row className="error-boundary" style={{position: 'absolute', bottom: '2%', zIndex: '20', width: '20%', right: '2%'}}>
            <Col sm={12}>
              <Portlet>
                <PortletTitle>
                  <PortletCaption>ERROR: Something went wrong</PortletCaption>
                </PortletTitle>
                <PortletBody>
                  <p>Please report this error with details below and login again.</p>
                  <p style={{ color: 'red' }}>
                    {this.state.error?.toString()}
                  </p>
                  <details>
                    <pre>
                      {this.state.errorInfo.componentStack}
                    </pre>
                  </details>
                </PortletBody>
              </Portlet>
            </Col>
          </Row>
        )}
      </React.Fragment>

    );
  }
}

export default ErrorBoundary;
